import { defineRecipe } from '@plurall/elo-v3';

export const creditsTriggerRecipe = defineRecipe({
  className: 'dashboard-header__credit-wrapper',
  base: {
    border: 'none',
    background: 'transparent',
    padding: 0,
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 'space.8',
    borderRadius: 'shape.4',
    '&:focus-visible': {
      outline: '2px solid var(--elo-colors-border-brand)',
      outlineOffset: '2px',
    },
  },
});

export const creditsTriggerIconRecipe = defineRecipe({
  className: 'dashboard-header__credit-wrapper-icon',
  base: {
    backgroundColor: 'background.primary',
    padding: 'space.4',
    borderRadius: 'shape.999',
  },
});

export const creditsTriggerTextRecipe = defineRecipe({
  className: 'dashboard-header__credit-wrapper-text',
  base: {
    fontWeight: 'font-weight-bold',
    fontSize: 'font-size-large',
    margin: 0,
    color: 'text.secondary',
    whiteSpace: 'nowrap',
    '& span': {
      fontWeight: 'font-weight-regular',
      fontSize: 'font-size-medium',
    },
  },
});

export const creditsModalContentRecipe = defineRecipe({
  className: 'credits-modal-content',
  base: {
    overflow: 'hidden',
    background: 'background.primary',
    padding: 'space.16',
    width: '100%',
    boxSizing: 'border-box',
    position: 'relative',
    zIndex: 1,
    borderRadius: 0,
    '&:first-child': {
      borderTopLeftRadius: 'shape.12',
      borderTopRightRadius: 'shape.12',
    },
    '&:last-child': {
      borderBottomLeftRadius: 'shape.12',
      borderBottomRightRadius: 'shape.12',
    },
    '&:not(:first-child)': {
      borderTop: '1px solid {colors.border.tertiary}',
    },
    '& > div': {
      marginBlockEnd: 'space.8',
    },
  },
});

export const creditsModalTitleRecipe = defineRecipe({
  className: 'credits-modal-title',
  base: {
    fontSize: 'font-size-xlarge',
    fontWeight: 'font-weight-semi-bold',
    color: 'foreground.brand',
    margin: 0,
  },
});

export const creditsModalCreditsRecipe = defineRecipe({
  className: 'credits-modal-credits',
  base: {
    fontWeight: 'font-weight-bold',
    fontSize: 'font-size-medium',
    margin: 0,
    color: 'text.secondary',
    '& span': {
      fontWeight: 'font-weight-regular',
    },
  },
});
